import { render, staticRenderFns } from "./ValorationLastYear.vue?vue&type=template&id=6c8bf1d2&scoped=true&lang=pug"
import script from "./ValorationLastYear.vue?vue&type=script&lang=js"
export * from "./ValorationLastYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8bf1d2",
  null
  
)

export default component.exports